import { render, staticRenderFns } from "./QuestionnaireForm.vue?vue&type=template&id=954facf2&scoped=true&"
import script from "./QuestionnaireForm.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireForm.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireForm.vue?vue&type=style&index=0&id=954facf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954facf2",
  null
  
)

export default component.exports